import Animation from './Animation';

export default class Wait extends Animation {

	constructor (master, time) {

		super(master, time, true);
	}
}


// WEBPACK FOOTER //
// ./src/game/view/animation/Wait.js